var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:[
    'checkbox-inline',
    {
      'checkbox-inline--indeterminated': _vm.indeterminated,
      'checkbox-inline--disabled-background': _vm.disabledBackground,
      'checkbox-inline--error': _vm.hasError
    }
  ],attrs:{"for":_vm.name}},[_c('input',{attrs:{"type":"checkbox","id":_vm.name,"name":_vm.name},domProps:{"checked":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.checked)}}}),_c('div',{staticClass:"checkbox-inline__body"},[_c('div',{staticClass:"checkbox-inline__check-container"},[(_vm.indeterminated)?_c('div',{staticClass:"checkbox-inline__indeterminated"}):_c('CheckIcon')],1),(_vm.label)?_c('Typography',{class:[
        'checkbox-inline__label',
        {
          'checkbox-inline__label--ellipsis': _vm.enableEllipsis,
          'checkbox-inline__label--bold': _vm.disabledBackground
        }
      ],attrs:{"variant":"body4"}},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]):_vm._e(),(_vm.componentToRender)?_c(_vm.componentToRender,{tag:"component",attrs:{"data":_vm.option}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }